import { createAnimation } from '@ionic/vue';
import { consumeGoingBack } from '@/animations/navigation-direction';

export const customTransition = (baseEl: HTMLElement, opts: any) => {
  const enteringEl = opts.enteringEl;
  const leavingEl = opts.leavingEl;
  const isBack = consumeGoingBack() || opts.direction === 'back';
  const duration = opts.duration ?? 300;
  const easing = opts.easing ?? 'cubic-bezier(0.4, 0, 0.2, 1)';

  const animation = createAnimation().duration(duration).easing(easing);

  if (enteringEl) {
    animation.addAnimation(
      createAnimation()
        .addElement(enteringEl)
        // forward : entre par la droite — back : entre légèrement par la gauche
        .fromTo('transform', isBack ? 'translateX(-30%)' : 'translateX(100%)', 'translateX(0%)')
        .fromTo('opacity', isBack ? '0.7' : '0', '1'),
    );
  }

  if (leavingEl) {
    animation.addAnimation(
      createAnimation()
        .addElement(leavingEl)
        // forward : sort légèrement à gauche — back : sort entièrement à droite
        .fromTo('transform', 'translateX(0%)', isBack ? 'translateX(100%)' : 'translateX(-30%)')
        .fromTo('opacity', '1', isBack ? '0' : '0.7'),
    );
  }

  return animation;
};
